import dayjs from "dayjs";

export const DEFAULT_TIME_ZONE = "Europe/Belgrade";

/**
 * A booking time as the salon's wall clock. Unlike the portal, this app lists
 * bookings across salons, so the zone travels with each booking's tenant — the
 * customer needs the hour they have to turn up at *that* salon, not the hour on
 * the device they happen to be holding.
 */
export const salonTime = (value?: string | Date | null, timeZone?: string) =>
  dayjs(value ?? undefined).tz(timeZone || DEFAULT_TIME_ZONE);
